'use client';

import React, { useState } from 'react';
import { Icon, validIcons } from '@brahma/components';
import styles from './languageSelector.module.scss';
import useGlobalContext from '$hooks/use-global-context';
import { ContextAction } from '$context/global-context/types';
import { useParams } from 'next/navigation';
import { updateURLForLocaleChange } from '$app/[lang]/(menu-header)/layout.helper';
import { COOKIE_NAME, DEFAULT_LNG, LANGUAGE_OPTIONS, MS_PER_DAY } from '$locale/constants';
interface LanguageSelectorProps {
  className?: string;
}
const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  className
}) => {
  const {
    state,
    dispatch
  } = useGlobalContext();
  const params = useParams();
  const [isOpen, setIsOpen] = useState(false);
  const currentLang = state?.locale?.lang || DEFAULT_LNG;
  const currentLanguage = LANGUAGE_OPTIONS.find(lang => lang.code === currentLang);
  const setCookie = (name: string, value: string, days: number = 365) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * MS_PER_DAY);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  };
  const handleLanguageChange = (langCode: string) => {
    // Set the language cookie immediately
    setCookie(COOKIE_NAME, langCode);

    // Update global state
    dispatch({
      type: ContextAction.setLang,
      payload: langCode
    });
    setIsOpen(false);

    // Update URL and reload page
    updateURLForLocaleChange(langCode, params.lang);
  };
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  return <div className={`${styles.languageSelector} ${className || ''}`} data-sentry-component="LanguageSelector" data-sentry-source-file="index.tsx">
      <button className={styles.languageButton} onClick={toggleDropdown} aria-label="Select language" type="button">
        <Icon iconName={validIcons.translate02} width="20" height="20" data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
        <span className={styles.languageText}>
          {currentLanguage?.nativeLabel}
        </span>
        <Icon iconName={validIcons.chevronDown} width="16" height="16" className={`${styles.chevron} ${isOpen ? styles.chevronOpen : ''}`} data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
      </button>

      {isOpen && <>
          <div className={styles.backdrop} onClick={() => setIsOpen(false)} />
          <div className={styles.dropdown}>
            {LANGUAGE_OPTIONS.map(lang => <button key={lang.code} className={`${styles.dropdownItem} ${lang.code === currentLang ? styles.active : ''}`} onClick={() => handleLanguageChange(lang.code)} type="button">
                <span className={styles.languageLabel}>{lang.nativeLabel}</span>
                {lang.code === currentLang && <Icon iconName={validIcons.check} width="16" height="16" />}
              </button>)}
          </div>
        </>}
    </div>;
};
export default LanguageSelector;